var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 124,
    viewBox: "0 0 96 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V124H96V0Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 124
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 0H6C2.68629 0 0 2.68629 0 6V118C0 121.314 2.68629 124 6 124H90C93.3137 124 96 121.314 96 118V6C96 2.68629 93.3137 0 90 0Z",
    fill: "#4E2AB9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V124H96V0Z",
    fill: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 108.5C47 109.328 46.3284 110 45.5 110C44.6716 110 44 109.328 44 108.5V88.5C44 87.6716 44.6716 87 45.5 87C46.3284 87 47 87.6716 47 88.5V108.5ZM41 104.5C41 105.328 40.3284 106 39.5 106C38.6716 106 38 105.328 38 104.5V92.5C38 91.6716 38.6716 91 39.5 91C40.3284 91 41 91.6716 41 92.5V104.5ZM33.5 102C34.3284 102 35 101.328 35 100.5V96.5C35 95.6716 34.3284 95 33.5 95C32.6716 95 32 95.6716 32 96.5V100.5C32 101.328 32.6716 102 33.5 102ZM62.5 102C63.3284 102 64 101.328 64 100.5V96.5C64 95.6716 63.3284 95 62.5 95C61.6716 95 61 95.6716 61 96.5V100.5C61 101.328 61.6716 102 62.5 102ZM51.5 106C52.3284 106 53 105.328 53 104.5V92.5C53 91.6716 52.3284 91 51.5 91C50.6716 91 50 91.6716 50 92.5V104.5C50 105.328 50.6716 106 51.5 106ZM57.5 108C58.3284 108 59 107.328 59 106.5V90.5C59 89.6716 58.3284 89 57.5 89C56.6716 89 56 89.6716 56 90.5V106.5C56 107.328 56.6716 108 57.5 108Z",
    fill: "#FF3C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9602 43.3453C55.7867 43.3453 52.4035 39.9686 52.4035 35.8031C52.4035 31.6377 55.7867 28.2609 59.9602 28.2609C64.1337 28.2609 67.5169 31.6377 67.5169 35.8031C67.5169 39.9686 64.1337 43.3453 59.9602 43.3453Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1624 43.3453C32.9889 43.3453 29.6057 39.9686 29.6057 35.8031C29.6057 31.6377 32.9889 28.2609 37.1624 28.2609C41.3359 28.2609 44.7191 31.6377 44.7191 35.8031C44.7191 39.9686 41.3359 43.3453 37.1624 43.3453Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8875 52.7364C23.1003 52.7364 21.6837 54.2749 22.0614 56.0183C24.6923 68.1622 35.5176 77.2609 48.4721 77.2609C61.4266 77.2609 72.2519 68.1622 74.8827 56.0183C75.2604 54.2749 73.8439 52.7364 72.0567 52.7364H24.8875Z",
    fill: "#CFCFCF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbAudio);
export default __webpack_public_path__ + "static/media/thumb_audio.9da8301c07d90a47061bbec525550f74.svg";
export { ForwardRef as ReactComponent };